(() => {
  if (customElements.get('bleau-research-declaration')) return;
  const allowedRoles = new Set(['independent researcher', 'MD', 'research foundation', 'research institute', 'analytical laboratory']);
  class ResearchDeclaration extends HTMLElement {
    connectedCallback() {
      this.roleInput = this.querySelector('select');
      this.confirmInput = this.querySelector('input[type="checkbox"]');
      this.error = this.querySelector('[role="alert"]');
      this.addEventListener('change', () => { this.error.textContent = ''; this.refresh(); });
      this.refresh();
    }
    refresh() {
      const valid = allowedRoles.has(this.roleInput.value) && this.confirmInput.checked;
      document.querySelectorAll('[name="checkout"]').forEach(button => {
        if (button.getAttribute('form') === this.dataset.form || button.form?.id === this.dataset.form) {
          button.disabled = !valid || this.busy || document.getElementById(this.dataset.form)?.querySelector('[name="updates[]"]') === null;
        }
      });
    }
    async proceed(event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (this.busy) return;
      if (!allowedRoles.has(this.roleInput.value) || !this.confirmInput.checked) {
        this.error.textContent = this.dataset.missingMessage;
        (!this.roleInput.value ? this.roleInput : this.confirmInput).focus();
        return;
      }
      this.busy = true;
      this.refresh();
      const attributes = {
        'Research purchaser type': this.roleInput.value,
        'Research-use declaration': 'confirmed',
        'Research-use declaration text': this.querySelector('.bleau-research-confirmation span').textContent.trim(),
        'Research-use declaration version': '2026-10-14',
        'Research-use declaration recorded at': new Date().toISOString()
      };
      attributes['Research-use checkout declaration'] = [
        attributes['Research-use declaration version'],
        attributes['Research purchaser type'],
        attributes['Research-use declaration'],
        attributes['Research-use declaration recorded at'],
        attributes['Research-use declaration text']
      ].join('|');
      try {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart/update.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ attributes })
        });
        if (!response.ok) throw new Error('Save failed');
        const cart = await response.json();
        if (!cart.item_count || Object.entries(attributes).some(([key, value]) => cart.attributes?.[key] !== value)) {
          throw new Error('Saved declaration did not match');
        }
        window.location.assign(root + 'checkout');
      } catch {
        this.error.textContent = this.dataset.saveError;
        this.busy = false;
        this.refresh();
      }
    }
  }
  customElements.define('bleau-research-declaration', ResearchDeclaration);
  document.addEventListener('click', event => {
    const button = event.target.closest('[name="checkout"]');
    if (!button) return;
    const formId = button.getAttribute('form') || button.form?.id;
    const declaration = Array.from(document.querySelectorAll('bleau-research-declaration')).find(el => el.dataset.form === formId);
    if (declaration) declaration.proceed(event);
  }, true);
  document.addEventListener('submit', event => {
    const declaration = Array.from(document.querySelectorAll('bleau-research-declaration')).find(el => el.dataset.form === event.target.id);
    if (declaration && event.submitter?.name === 'checkout') declaration.proceed(event);
  }, true);
})();
